import { useState } from 'react'
import { blockKey } from './blockKey'

/**
 * Enter animation plays once per block in this mount. Historical threads
 * (`animateEnter` false on first paint) skip; later arrivals still enter.
 */
export function useEnteredBlockKeys(blocks, animateEnter) {
  const keys = (blocks ?? []).map((block, index) => blockKey(block, index))
  const [store, setStore] = useState(() => ({
    entered: new Set(animateEnter ? keys : []),
    skipped: new Set(animateEnter ? [] : keys),
  }))
  const missing = keys.filter((key) => !store.skipped.has(key) && !store.entered.has(key))
  if (missing.length) {
    setStore({
      entered: new Set([...store.entered, ...missing]),
      skipped: store.skipped,
    })
  }
  return store.entered
}
